// @ts-nocheck
import { Plugin } from '/hdapp/jenkins/agent/test19/workspace/iWMS/iWMS-platform-web-release-test-docker-maven/node_modules/_@umijs_runtime@3.5.43@@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu','dva','getInitialState','initialStateConfig','locale','request',],
});

export { plugin };
